import { FC, Fragment } from 'react';
// Components
import { Fab } from 'app/components/Mui';
// Hooks
import useToggle from 'app/hooks/useToggle';
import useAccountStatus from 'app/hooks/useAccountStatus';
// i18next
import { useTranslation } from 'react-i18next';
//
import CollectionFormDialog from './CollectionFormDialog';

const CollectionsFab:FC = () => {
  const { t } = useTranslation();

  const { isSuspended } = useAccountStatus();
  const { open, toggle } = useToggle();
  return (
    <Fragment>
      <Fab
        name="Create collection"
        sx={{
          position: 'fixed',
          right: 16,
          bottom: 16
        }}
        onClick={toggle}
        color="primary"
        variant="extended"
        disabled={isSuspended}
      >{t('pages.collections.createButton')}</Fab>
      {/* Dialog */}
      {open ? (
        <CollectionFormDialog
          open={open}
          onClose={toggle}
        />
      ) : null}
    </Fragment>
  )
}

export default CollectionsFab;
